import Checkpoint from '../Model/Checkpoint';
export default class CheckpointsFactory {
    constructor(activitiesService) {
        this.activitiesService = activitiesService;
    }
    createCheckpoint(checkpointState) {
        return new Checkpoint(this.activitiesService, checkpointState);
    }
}
